import { skuSortPriority } from 'features/licenses/consts'
import { LICENSES_IMPORT_FILTERS, LicenseType } from 'features/licenses/types'

export const licensesDefaultSort = (licensesGroup: LicenseType[]) => {
  const groupName = licensesGroup[0].name
  const sortPriority = skuSortPriority.indexOf(groupName)
  return sortPriority === -1 ? Number.POSITIVE_INFINITY : sortPriority
}

export const prettyLicenseDescription = (
  description: LicenseType['description']
) =>
  description?.replace(/savant da vinci software - /i, '') || 'No description'

export const licenseFiltersMap = {
  [LICENSES_IMPORT_FILTERS.rma]: (_: string | null, license: LicenseType) =>
    license.enabled === false,
  [LICENSES_IMPORT_FILTERS.transferred]: (
    currentRootDomainId: string | null,
    license: LicenseType
  ) => {
    const availableLicenseImported =
      license.domainId && license.domainId !== currentRootDomainId
    const activatedLicenseImported =
      license.homeRootDomainId &&
      license.homeRootDomainId !== currentRootDomainId
    const youPurchasedLicense =
      license.purchaserDomainId === currentRootDomainId
    const transferredLicense =
      (availableLicenseImported || activatedLicenseImported) &&
      youPurchasedLicense
    return Boolean(transferredLicense)
  },
}
